interface Props {
  title: string,
  className?: string
}

const DropdownMenuHeader = ({ title, className }: Props) => {
  return (
    <hot-dropdown-menu-header className={className} slot="menu">
      {title}
    </hot-dropdown-menu-header>
  )
}

export default DropdownMenuHeader
